<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span v-if="isLoadedOrder" class="font-weight-medium">
            {{ $t('ORDERS.ITEM') }} {{ order.order_number }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'customer-order-repetitive.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <order-customer-form
              v-if="isLoadedOrder"
              v-model="order"
              :person="person"
              :action="action"
              readonly
            ></order-customer-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <tasks-list
              v-if="isLoadedOrder"
              ref="tasksList"
              :tasks="orderTasksListResponse"
              @show="show"
              @refresh="getDataTasks"
            ></tasks-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="1400px">
      <view-event-task
        v-if="taskId"
        :id="taskId"
        @updated="cancelDialogAndRefresh"
        @removed="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      ></view-event-task>
    </v-dialog>
  </v-container>
</template>

<script>
import order from '../../mixins/order';
import OrderCustomerForm from './../../../components/forms/OrderCustomerForm';
import TasksList from './../../../components/TasksList';
import { mapActions, mapGetters } from 'vuex';
import { SHOW } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'CustomerOrderShowPage',

  components: {
    OrderCustomerForm,
    TasksList,
    ViewEventTask: () =>
      import('@/modules/plannings/components/Event/ViewEventTask')
  },

  mixins: [order],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    person: {},
    dialog: false,
    taskId: null,
    action: SHOW,
    orderTasksListResponse: {
      data: []
    }
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  mounted() {
    this.$vuetify.goTo(0);
    this.getOrderRC({ orderId: this.id }).then(({ data }) => {
      this.person = data.person;
      this.order = data;
    });

    this.getDataTasks();
  },

  methods: {
    ...mapActions('order', ['getOrderRC', 'getOrderTasksList']),
    getDataTasks() {
      this.getOrderTasksList({ orderId: this.id }).then(({ data }) => {
        this.orderTasksListResponse = data;
      });
    },
    show(item) {
      this.taskId = item.id;
      this.dialog = true;
    },
    cancelDialog() {
      this.dialog = false;
      this.taskId = null;
    },
    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.$refs.tasksList.refreshData();
    }
  }
};
</script>
